<template>
  <div class="course-ul">
    <!-- 循环渲染每个课程 -->
    <div class="course-li" v-for="course in courses" :key="course.id" @click="gotoCourseDetails(course)">
      <!-- 根据是否已观看来显示未观看标签 -->
      <div
        :class="[
          'none',
          isLiveStreaming != '1' && getWatchStatus(course).includes('观看至') ? 'partial' : '',
          isLiveStreaming != '1' && getWatchStatus(course) === '已观看' ? 'watched' : ''
        ]"
        v-if="isLiveStreaming != '1'"
      >
        {{ getWatchStatus(course) }}
      </div>
      <div :class="[course.status == 'LIVING' ? 'none' : 'none-two']" v-if="isLiveStreaming == '1'">{{ course.status == 'LIVING' ? '未观看' : '已结束' }}</div>
      <div v-if="isLiveStreaming != '1'" class="courseDurationFormat">{{course.courseDurationFormat}}</div>
      <div class="course-img">
        <img v-if="isLiveStreaming != '1' && course.image && course.image.url != undefined" :src="course.image.url" alt="课程封面" />
        <img v-if="isLiveStreaming != '1' && !course.image" src="@/assets/images/logo-img.png" alt="">
        <img v-if="isLiveStreaming == '1' && course.detailImage && course.detailImage.url != undefined" :src="course.detailImage.url" alt="直播封面" />
        <img v-if="isLiveStreaming == '1' && !course.detailImage" src="@/assets/images/logo-img.png" alt="">
      </div>
      <div class="course-text">
        <div class="course-time">{{ course.createTimeFormat }}</div>
        <div class="course-p">{{ course.title }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Course",
  props: {
    courses: {
      type: Array,
      required: true // 父组件传递课程列表
    },
    watchedList: {
      type: Array,
      required: true // 父组件传递已观看课程 ID 列表
    },
    isLiveStreaming: {
      type: String,
      default: '',
    }
  },
  methods: {
    islogin() {
      let token = localStorage.getItem("x-token")
      if (token == null) {
        this.$router.push({ path: `/codeLogin` });
        return false
      }
      return true
    },
    getWatchStatus(course) {
      // 如果没有学习记录 或 duration 为 0
      if (!course.learningProgress || course.learningProgress.duration == 0) {
        return '未观看';
      }

      const watched = course.learningProgress.duration;
      const total = course.courseDurationFormat; // 假设格式是字符串，比如 "00:30:00"

      // 转换为秒数
      const timeToSeconds = (timeStr) => {
        const parts = timeStr.split(':').map(Number);
        if (parts.length === 3) {
          return parts[0] * 3600 + parts[1] * 60 + parts[2];
        } else if (parts.length === 2) {
          return parts[0] * 60 + parts[1];
        } else {
          return parseInt(timeStr); // 防止后端只给了秒数
        }
      };

      const totalSeconds = timeToSeconds(total);

      if (!totalSeconds || totalSeconds === 0) return '未观看';

      if (watched >= totalSeconds) {
        return '已观看';
      }

      const percent = Math.floor((watched / totalSeconds) * 100);
      return `观看至${percent}%`;
    },
    // 判断当前课程是否已经观看
    gotoCourseDetails(value) {
      if (!this.islogin()) {
        return;
      }
      if(this.isLiveStreaming != '1') {
        this.$emit('gotoCourseDetails')
        this.$router.push({ path: `/CourseDetails/${value.id}` }); // 动态路由传递课程 id
      }else {
        window.open(value.liveAddress)
      }
    },
    isWatched(courseId) {
      return this.watchedList.includes(courseId);
    }
  }
};
</script>
<style lang="less">
.el-pagination .el-select .el-input .el-input__inner{
  height: 32px;
}
</style>
<style scoped lang="less">
.course-ul {
  display: flex;
  // justify-content: space-between;
  flex-wrap: wrap;
  gap: 24px;
  margin-top: 20px;
}
.course-li:hover{
  .course-text{
    .course-p{
      color: #9C1D22;
      font-weight: bold;
    }
  }
}
.course-li {
  width: 307px;
  position: relative;
  background: #fff;
  cursor: pointer;
  .partial {
    background: #EA580C !important; // 例如：橙色
  }
  .watched {
    background: #737373 !important; // 例如：绿色
  }
  .none{
    position: absolute;
    left: 10px;
    top: 10px;
    background: #9C1D22;
    color: #fff;
    font-size: 14px;
    padding: 4px 6px;
  }
  .courseDurationFormat{
    position: absolute;
    right: 10px;
    top: 10px;
    color: #fff;
    background: rgba(0, 0, 0,.4);
    padding: 4px 6px;
    display: flex;
    font-size: 14px;
    align-items: center;
    justify-content: center;
  }
  .none-two{
    position: absolute;
    left: 10px;
    top: 10px;
    background: #737373;
    color: #fff;
    font-size: 14px;
    padding: 4px 6px;
  }
  .course-text{
    padding: 16px;
    text-align: left;
    .course-time{
      font-size: 16px;
      line-height: 16px;
      color: #999999;
      margin-bottom: 12px;
    }
    .course-p{
      color: var(---, #222);
      font-size: 18px;
      line-height: 26px;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
  .course-img {
    width: 307px;
    height: 190px;
    overflow: hidden;
    img{
      width: 100%;
      height: 100%;
      object-fit: cover;  /* 保持比例填充并裁剪 */
      display: block;
    }
  }
}

.none {
  position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/components/course/index.vue